/**
 * Asynchronously loads the component for DealerInventoriesPage
 */

import { lazyLoad } from 'utils/loadable';

export const DealerInventoriesPage = lazyLoad(
  () => import('./index'),
  module => module.DealerInventoriesPage,
);
